import styled from 'styled-components'

const Styled404 = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  a {
    margin-top: 10px;
    text-decoration: underline;
  }
  h1 {
    font-family: ${({ theme }) => theme.fonts.playfairDisplay};
  }
  .message {
    margin: 40px 0;
  }
`

export default Styled404
